import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// Same breadcrumb pattern as the FileUploader admin pages (CreateEditTemplatePage).
export default function RegistryBreadcrumbs({ projectId, current }) {
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      <Link
        component={RouterLink}
        to={`/projects/${projectId}/registry`}
        underline="hover"
        color="inherit"
        variant="body2"
      >
        Research Registry
      </Link>
      <Typography variant="body2" color="text.primary">
        {current}
      </Typography>
    </Breadcrumbs>
  );
}
